// slices/resetAllSlice.ts
import { StateCreator } from 'zustand'
import { IResetSlice } from '@/types'
import { TopicsCacheKey } from '@/utils/cacheKeys'
import createAppSlice from './appSlice'
import createHomeSlice from './homeSlice'
import createUserSlice from './userSlice'
import createEditSlice from './editSlice'
import createSearchSlice from './searchSlice'
import createNotificationSlice from './notificationSlice'

export const resetAllSlices: StateCreator<any, [], [], IResetSlice> = (set, get) => ({
  resetAll: () => {
    const state = get()

    Object.values(TopicsCacheKey).forEach((key) => {
      const slice = state[key]
      if (slice && typeof slice.reset === 'function') {
        slice.reset()
      } else {
        console.warn(`resetAllSlices: no reset() found on slice "${key}"`)
      }
    })

    createAppSlice(set).reset()
    createHomeSlice(set).reset()
    createUserSlice(set).reset()
    createEditSlice(set).reset()
    createSearchSlice(set).reset()
    createNotificationSlice(set).reset()
  },
})
